import {
  GET_TESTIMONIALS,
  GET_TESTIMONIALS_SUCCESS,
  GET_TESTIMONIALS_FAIL,
  GET_TESTIMONIAL_DETAILS,
  GET_TESTIMONIAL_DETAILS_SUCCESS,
  GET_TESTIMONIAL_DETAILS_FAIL,
  CREATE_TESTIMONIAL,
  CREATE_TESTIMONIAL_SUCCESS,
  CREATE_TESTIMONIAL_FAIL,
  UPDATE_TESTIMONIAL,
  UPDATE_TESTIMONIAL_SUCCESS,
  UPDATE_TESTIMONIAL_FAIL,
  DELETE_TESTIMONIAL_SUCCESS,
  DELETE_TESTIMONIAL_FAIL,
  DELETE_TESTIMONIAL,

} from "./actionTypes"

// Testimonial - This line cannot be edited or removed
export const getTestimonials = (
  page,
  limit,
  searchText,
  testimonialId,

) => ({
  type: GET_TESTIMONIALS,
  payload: { page, limit, searchText, testimonialId,  },
})

export const getTestimonialsSuccess = testimonials => ({
  type: GET_TESTIMONIALS_SUCCESS,
  payload: testimonials,
})

export const getTestimonialsFail = error => ({
  type: GET_TESTIMONIALS_FAIL,
  payload: error,
})

export const getTestimonialDetails = testimonialId => ({
  type: GET_TESTIMONIAL_DETAILS,
  payload: testimonialId,
})

export const getTestimonialDetailsSuccess = clientDetails => ({
  type: GET_TESTIMONIAL_DETAILS_SUCCESS,
  payload: clientDetails,
})

export const getTestimonialDetailsFail = error => ({
  type: GET_TESTIMONIAL_DETAILS_FAIL,
  payload: error,
})

export const createTestimonial = (testimonial, onCloseClick) => ({
  type: CREATE_TESTIMONIAL,
  payload: { testimonial, onCloseClick },
})

export const createTestimonialSuccess = testimonial => ({
  type: CREATE_TESTIMONIAL_SUCCESS,
  payload: testimonial,
})

export const createTestimonialFail = error => ({
  type: CREATE_TESTIMONIAL_FAIL,
  payload: error,
})

export const getTestimonialDetail = testimonialId => ({
  type: GET_TESTIMONIAL_DETAILS,
  payload: testimonialId,
})

export const updateTestimonial = (testimonial, testimonialId, onCloseClick) => ({
  type: UPDATE_TESTIMONIAL,
  payload: { testimonial, testimonialId, onCloseClick },
})

export const updateTestimonialSuccess = testimonial => ({
  type: UPDATE_TESTIMONIAL_SUCCESS,
  payload: testimonial,
})

export const updateTestimonialFail = error => ({
  type: UPDATE_TESTIMONIAL_FAIL,
  payload: error,
})

export const deleteTestimonial = testimonialId => ({
  type: DELETE_TESTIMONIAL,
  payload: { testimonialId },
})

export const deleteTestimonialSuccess = testimonial => ({
  type: DELETE_TESTIMONIAL_SUCCESS,
  payload: testimonial,
})

export const deleteTestimonialFail = error => ({
  type: DELETE_TESTIMONIAL_FAIL,
  payload: error,
})
